import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { russianCheckingAccountSchema } from '@zaoblako/shared/modules/serde/schemas/russian-checking-account.schema';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import type { BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';
import type { SerdeContextInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context.interface';

import * as yup from 'yup';

/** BRS task counterparty's bank details form */
export interface TaskContragentBankDetailsFormInterface {
  /** Unique identifier. Required by some other bodies. */
  id?: number;
  /** Is this bank details was selected for BRS task */
  isSelected?: boolean;
  /** Checking account number */
  bank?: BankFindInterface;
  /** Checking account number */
  checkingAccount?: string;
}

const optionalIfIdDefined = (
  context: SerdeContextInterface<SerdeContextDataInterface, TaskContragentBankDetailsFormInterface>,
): boolean => Boolean(context?.value?.id);

const USING_ONLY_ON_NEW_HINT = 'Использутеся только для счета: когда не заполнено поле `id`';

/** BRS task counterparty's bank details form */
export const TaskContragentBankDetailsFormDto = SerdeDtoClass.create<TaskContragentBankDetailsFormInterface>(
  TaskDtoKeysEnum.TASK_CONTRAGENT_BANK_DETAILS_FORM_DTO,
  {
    id: {
      optional: true,
      label: 'Номер',
      serializer: idLikeSchema,
      checkers: [ClientCheckerKeysEnum.BANK_DETAILS_ASSERT_EXISTS_BY_ID],
    },
    isSelected: {
      optional: true,
      label: 'Выбран',
      serializer: yup.boolean(),
    },
    bank: {
      optional: optionalIfIdDefined,
      label: 'Банк',
      hint: USING_ONLY_ON_NEW_HINT,
      serializer: entityLikeSchema,
    },
    checkingAccount: {
      optional: optionalIfIdDefined,
      hint: USING_ONLY_ON_NEW_HINT,
      label: 'Номер рассчетного счета',
      serializer: russianCheckingAccountSchema,
    },
  },
);
